import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ConferanceForm = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    first_name: Yup.string().required(t("common.firstNameValidation")),
    last_name: Yup.string().required(t("common.lastNameValidation")),
    email: Yup.string().email("").required(t("common.emailValidation")),
    jobtitle: Yup.string().required(t("common.jopTitleValidation")),
    phone: Yup.string()
      .matches(/^05\d{8}$/, t("common.phoneValidation1"))
      .required(t("common.phoneValidation2")),
  });

  const handleSave = async (values) => {
    try {
      await validationSchema.validate(values, { abortEarly: false });
      const formData = new FormData();

      for (const key in values) {
        if (values.hasOwnProperty(key)) {
          formData.append(key, values[key]);
        }
      }
      axios
        .post("https://admin.fmexcon.com/api/conferanceRegisterStore", formData)
        .then((res) => {
          toast.success(res?.data?.message);
          navigate(
            `${
              i18n.language === "en"
                ? `/en/pdf#conditions`
                : `/ar/pdf#conditions`
            }`
          );
        })
        .catch((err) => {
          console.error(err);
          toast.success(err);
        });
    } catch (err) {
      console.error("Validation errors:", err.errors);
    }
  };

  return (
    <Formik
      initialValues={{
        first_name: "",
        last_name: "",
        email: "",
        company: "",
        jobtitle: "",
        phone: "",
        website: "",
        message: "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        formikBag.setErrors({});
      }}
    >
      {({
        handleSubmit,
        errors,
        touched,
        values,
        isSubmitting,
        setFieldValue,
      }) => (
        <Form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto p-4">
          <p className="text-3xl px-4 text-[#44add2] text-center font-bold -mt-4 mb-4">
            {t("conference.registerWithUs")}
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
            <div className="flex flex-col">
              <label>
                {t("conference.firstName")}{" "}
                <span className="text-red-700 text-xl">*</span>
              </label>
              <Field
                name="first_name"
                className="w-full bg-gray-100 rounded-lg border border-gray-200 outline-none p-2"
                placeholder={t("conference.firstName")}
                value={values.first_name}
                onChange={(e) => {
                  setFieldValue("first_name", e.target.value);
                }}
              />
              <ErrorMessage
                name="first_name"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
            <div className="flex flex-col">
              <label>
                {t("conference.lastName")}{" "}
                <span className="text-red-700 text-xl">*</span>
              </label>
              <Field
                name="last_name"
                className="w-full bg-gray-100 rounded-lg border border-gray-200 outline-none p-2"
                placeholder={t("conference.lastName")}
                value={values.last_name}
                onChange={(e) => {
                  setFieldValue("last_name", e.target.value);
                }}
              />
              <ErrorMessage
                name="last_name"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
          </div>

          <div className="flex flex-col mb-4">
            <label>
              {t("conference.emailAddress")}{" "}
              <span className="text-red-700 text-xl">*</span>
            </label>
            <Field
              name="email"
              type="email"
              className="w-full bg-gray-100 rounded-lg border border-gray-200 outline-none p-2"
              placeholder={t("conference.emailAddress")}
              value={values.email}
              onChange={(e) => {
                setFieldValue("email", e.target.value);
              }}
            />
            <ErrorMessage
              name="email"
              component="div"
              className="text-red-500 text-sm"
            />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
            <div className="flex flex-col">
              <label>
                {t("conference.phoneNumber")}{" "}
                <span className="text-red-700 text-xl">*</span>
              </label>
              <Field
                name="phone"
                className="w-full bg-gray-100 rounded-lg border border-gray-200 outline-none p-2"
                placeholder={t("conference.phoneNumber")}
                value={values.phone}
                onChange={(e) => {
                  setFieldValue("phone", e.target.value);
                }}
              />
              <ErrorMessage
                name="phone"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
            <div className="flex flex-col">
              <label>
                {t("conference.jobTitle")}{" "}
                <span className="text-red-700 text-xl">*</span>
              </label>
              <Field
                name="jobtitle"
                className="w-full bg-gray-100 rounded-lg border border-gray-200 outline-none p-2"
                placeholder={t("conference.jobTitle")}
                value={values.jobtitle}
                onChange={(e) => {
                  setFieldValue("jobtitle", e.target.value);
                }}
              />
              <ErrorMessage
                name="jobtitle"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
          </div>
          <div>
            <button
              type="submit"
              onClick={() => {
                handleSave(values);
              }}
              className="py-2 px-12 lg:w-fit md:w-fit w-full rounded-md text-white font-bold text-sm bg-[#44add2] hover:bg-[#319cc4]"
            >
              {t("conference.b2")}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ConferanceForm;
